export class UserState {
  acccessToken?: string;

  idToken?: string;

  refreshToken?: string;
}
